import cn from 'classnames';
import {PropsWithChildren} from 'react';
import './button.sass';

interface IProps {
  type?: 'button' | 'submit' | 'reset' | undefined;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  component?: 'a';
  href?: string;
}

const Button: React.FC<PropsWithChildren<IProps>> = ({
  children,
  className,
  onClick,
  disabled,
  type = 'button',
  component,
  href,
}) => {
  const Component = component || 'div';
  return (
    <button className={cn('button', className, disabled && '_disabled')} onClick={onClick} type={type}>
      <Component href={href} className="button__inner">
        {children}
      </Component>
    </button>
  );
};

export default Button;
